export default __webpack_public_path__ + "static/media/wave.bc9bd273.svg";